import { cn } from "@/lib/utils";
import type { ComponentProps, FC } from "react";
import { LuStethoscope } from "react-icons/lu";

export const MedicalCheckupIcon: FC<ComponentProps<typeof LuStethoscope>> = ({
  className,
  ...props
}) => (
  <LuStethoscope {...props} className={cn("size-5.5 fill-none!", className)} />
);
